import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/tip-comparison',
  component: () => import('../../routes/TipComparison.svelte'),
  card: {
    id: 'tip-comparison',
    title: 'Tip Comparison',
    description: 'Compare tip amounts across different service quality levels side-by-side.',
    icon: 'restaurant',
    iconBgClass: 'bg-rose-50',
    iconTextClass: 'text-rose-600',
    href: '/tip-comparison',
    category: 'Life & Budget',
  },
  seo: {
    title: 'Tip Comparison Calculator – Compare Tip Percentages by Service Quality',
    description:
      'Compare tip amounts across 10%, 15%, 18%, 20%, and 25% to find the right tip for any service level. See how much extra a great server earns vs counter service.',
  },
};

export default meta;
